module.exports = __webpack_public_path__ + "img/pray.27e7d589.gif";